import React from "react";
import { ShieldCheck, LockKey } from "@phosphor-icons/react";

export function SecurityBadge({ compact = false, className = "" }) {
  if (compact) {
    return (
      <div
        data-testid="security-badge-compact"
        className={`inline-flex items-center gap-1.5 text-[11px] font-mono px-2 py-1 rounded-md border border-[var(--vs-border)] bg-white text-[var(--vs-secondary)] ${className}`}
      >
        <LockKey size={12} weight="fill" />
        AES-256-GCM
      </div>
    );
  }
  return (
    <div
      data-testid="security-badge"
      className={`flex items-start gap-3 p-4 border border-[var(--vs-border)] rounded-md bg-white ${className}`}
    >
      <div className="mt-0.5 text-[var(--vs-secondary)]">
        <ShieldCheck size={22} weight="duotone" />
      </div>
      <div className="text-sm">
        <div className="font-display font-semibold text-[var(--vs-text)]">Encrypted via AES-256-GCM</div>
        <div className="text-[var(--vs-text-secondary)] text-xs">
          PII fields (Aadhar, address, phone, guardian) are sealed at rest. TLS 1.2+ protects data in transit.
        </div>
      </div>
    </div>
  );
}
